import VStore from './src/VStore'

VStore.install = (Vue, $store) => {
  Vue.prototype.$store = $store
}

export * from './src/helpers'
export default VStore
